import watermarkBase64 from "./assets/watermark-base64";

export const addWatermarkImage = (workbook, worksheet, totalCols, rowHeight = 50) => {
    // Merge first row across all columns
    worksheet.mergeCells(1, 1, 1, totalCols);
    worksheet.getRow(1).height = rowHeight;

    const imageId = workbook.addImage({
        base64: watermarkBase64,
        extension: "png",
    });

    const imageWidth = 2024;
    const imageHeight = 544;
    const aspectRatio = imageWidth / imageHeight;

    // Just place the image at top-left
    worksheet.addImage(imageId, {
        tl: { col: 0, row: 0 },
        ext: { width: aspectRatio * rowHeight, height: rowHeight },
    });
};